// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const defConfig = {
  with_twoDigitMinutes: true,
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

function convert_floatToTimeString(FLOAT, CONFIG = defConfig) {
  // Setup //
  const config = { ...defConfig, ...CONFIG };
  const { with_twoDigitMinutes } = config;

  // Extract + format mintues //
  const min = Math.floor(FLOAT / 60);
  const min_formatted = with_twoDigitMinutes ? (min < 10 ? `0${min}` : min) : min;

  // Extract + format seconds //
  const sec_remaining = Math.floor(FLOAT % 60);
  const sec_formatted = sec_remaining < 10 ? `0${sec_remaining}` : sec_remaining;

  return `${min_formatted}:${sec_formatted}`;
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default convert_floatToTimeString;
